<template>
  <div
    v-tooltip="{
      content: hint,
      //show:true,
      show: wordIsSelected,
      offset: 20,
      placement: this.computedPlacement,
      trigger: 'manual',
      classes: [className, 'tooltip-word', `tooltip-${index + 1}`, `${computedColor}`, `br2 ph2 pv1 mb0 mt0 pl2 pr2 f4-l f5-m f5`],
    }"
    v-bind:style="gridStyles"
    v-bind:class="[className, isValid && 'valid', , `${computedColor}`]"
  ></div>
</template>

<script>
export default {
  inject: ["getLevelDisplay"],
  methods: {
    showDemo: function() {
      this.wordIsSelected = true;
    },
    hideDemo: function() {
      this.wordIsSelected = false;
    },
    setValid: function isValid() {
      this.isValid = this.cells.every(c => c && c.isValid);
    }
  },
  props: {
    color: String,
    index: Number,
    values: Array,
    clue: String,
    row: Number,
    col: Number,
    type: String,
    hint: String,
    placement: String
  },
  data: function() {
    return {
      wordIsSelected: false,
      firstPaint: true,
      isValid: false
    };
  },
  created: function() {
    this.placements = this.values.map((val, index) => {
      let row, col;
      if (this.type === "horizontal") {
        row = this.row;
        col = this.col + index;
      } else {
        row = this.row + index;
        col = this.col;
      }
      return {
        row,
        col
      };
    });
  },
  mounted: function() {
    this.setValid();
    setTimeout(() => {
      this.wordIsSelected = true;
    }, (this.index + 0.1) * 1000);

    setTimeout(() => {
      this.wordIsSelected = false;
    }, (this.index + 1.1) * 1000);

    this.$root.$on("cell:selected", infos => {
      const { row, col } = infos;
      if (this.cells.find(c => c && c.row === row && c.col === col)) {
        this.wordIsSelected = true;
        this.$root.$emit("word:selected", this.$props);
      } else {
        this.wordIsSelected = false;
      }
    });
    this.$root.$on("image:placed", () => {
      this.wordIsSelected = false;
    });

    this.$root.$on("words:deselect", () => {
      this.wordIsSelected = false;
    });
    this.$root.$on("grid:changed", () => {
      setTimeout(() => {
        this.setValid();
      }, 10);
    });
    this.$root.$on("cell:changed", () => {
      setTimeout(() => {
        this.setValid();
      }, 10);
    });
  },
  computed: {
    computedColor: function() {
      if (this.color) {
        return this.color;
      }
      switch (this.index) {
        case 0:
          return "cyan";
        case 1:
          return "pink";
        case 2:
          return "purple";
        case 3:
          return "orange";
        case 4:
          return "yellow";
        case 5:
          return "red";
        case 6:
          return "blue";
        default:
          return "green";
      }
    },
    computedPlacement: function() {
      if (this.placement) {
        return this.placement;
      } else {
        if (this.type === "vertical") {
          return "top-center";
        }
        return "left-center";
      }
    },
    cells: function() {
      return this.placements.map(c => {
        return this.$parent.getCell({
          row: c.row,
          col: c.col
        });
      });
    },

    gridStyles: function() {
      const styles = {
        "grid-row-start": this.row,
        "grid-column-start": this.col,
        "flex-direction": this.type === "vertical" ? "column" : "row"
      };
      if (this.type === "horizontal") {
        styles["grid-column-end"] = this.col + this.values.length;
      }
      if (this.type === "vertical") {
        styles["grid-row-end"] = this.row + this.values.length;
      }
      return styles;
    },
    filled: function() {
      return this.cells.every(c => c.value);
    },
    className: function() {
      if (!this.filled) {
        return "";
      }
      return this.isValid ? "valid" : "invalid";
    }
  },
  watch: {
    isValid: function() {
      if (this.isValid) {
        this.$root.$emit("word:valid");
      }
    }
  }
};
</script>

<style scoped>
.word {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
}

.v-tooltip-open {
  z-index: 2;
  /* border: 5px solid #03a3e4; */
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #1a73e8; */
  pointer-events: none;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.valid {
box-shadow: none !important;
}


.v-tooltip-open.yellow::after {
  border: 2px solid #fcc934;
}

.v-tooltip-open.red::after {
  border: 2px solid #d93025;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #d93025; */
}

.v-tooltip-open.blue::after {
  border: 2px solid #1a73e8;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #1a73e8; */
}

.v-tooltip-open.green::after {
  border: 2px solid #1e8e3e;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #1e8e3e; */
}

.v-tooltip-open.orange::after {
  border: 2px solid #e8710a;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #e8710a; */
}

.v-tooltip-open.pink::after {
  border: 2px solid #e52592;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #e52592; */
}

.v-tooltip-open.purple::after {
  border: 2px solid #9334e6;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #9334e6; */
}

.v-tooltip-open.cyan::after {
  border: 2px solid #12b5cb;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 7px #12b5cb; */
}

.v-tooltip-open.yellow.valid::after,
.v-tooltip-open.red.valid::after,
.v-tooltip-open.blue.valid::after,
.v-tooltip-open.green.valid::after,
.v-tooltip-open.orange.valid::after,
.v-tooltip-open.pink.valid::after,
.v-tooltip-open.purple.valid::after,
.v-tooltip-open.cyan.valid::after {
  border: 2px solid #1a73e8;
  /* box-shadow: 0 0 0 5px #f7f7f7, 0 0 0 10px #1a73e8; */
}


.v-tooltip-open::after {
  content: " ";
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: content-box;
  padding: 5px;
  border-radius: 15px;
}


.valid::after {
  content: " ";
  position: absolute;
  border: 5px solid #1a73e8 !important;
  width: 100%;
  height: 100%;
  box-sizing: content-box;
  padding: 5px;
  border-radius: 15px;

}

</style>

<style>
div.tooltip {
  color: white;
  /* border-radius:.25rem; */
  /* border-radius: 5px;
  padding: 0.5rem 1rem;
  font-size: 1.5rem; */
  pointer-events: none;
  z-index: 4;
  border-radius: 100px;
}
div.images-tooltip {
  z-index: 100;
}

.tooltip.yellow {
  background: #fcc934;
}

.tooltip.red {
  background: #d93025;
}

.tooltip.blue {
  background: #1a73e8;
}

.tooltip.green {
  background: #1e8e3e;
}

.tooltip.orange {
  background: #e8710a;
}

.tooltip.pink {
  background: #e52592;
}

.tooltip.purple {
  background: #9334e6;
}

.tooltip.cyan {
  background: #12b5cb;
}

@media screen and (max-width: 1000px) {
  .tooltip {
    padding: 0.2rem 0.5rem;
    font-size: 1rem;
  }
}
</style>
